module.exports = __webpack_public_path__ + "img/bg-ellipse.d4c603d1.svg";